import { Link } from 'react-router';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
  @media screen and (max-width: 800px) {
    &&& {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-left: -20px;
      padding: 20px;
    }
  }
`;
